import Modal from '../../components/Modal';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Request from '../../utils/request';

const CHANGE_EVENT = 'change';
const CLICK_EVENT = 'click';

class EditPlayers {
	constructor() {
		this.payload = {
			updateCoachDetailsRequest: {
				myPlayers: {
					playerAgeGroups: [],
					skills10AndUnder: [],
					skills11To14: [],
					skills15To18: [],
					skillsAdultsOrSeniors: []
				}
			}
		};
		this._container = SelectorEngine.findOne('.js-edit-coach-details-players');

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._form = SelectorEngine.findOne('#lta-coach-details__edit-players-details-form', this._container);

		this.playerAgeGroupsValidationWrapper = SelectorEngine.findOne('.lta-age-group', this._container);
		this.skills10AndUnderValidationWrapper = SelectorEngine.findOne('.skills10AndUnder', this._container);
		this.skills11To14ValidationWrapper = SelectorEngine.findOne('.skills11To14', this._container);
		this.skills15To18ValidationWrapper = SelectorEngine.findOne('.skills15To18', this._container);
		this.skillsAdultsOrSeniorsValidationWrapper = SelectorEngine.findOne('.skillsAdultsOrSeniors', this._container);

		this._ageGroupValidationErrorText = SelectorEngine.findOne(
			'.lta-text-input--error',
			this.playerAgeGroupsValidationWrapper
		);
		this._skills10AndUnderValidationErrorText = SelectorEngine.findOne(
			'.lta-text-input--error',
			this.skills10AndUnderValidationWrapper
		);
		this._skills11To14ValidationErrorText = SelectorEngine.findOne(
			'.lta-text-input--error',
			this.skills11To14ValidationWrapper
		);
		this._skills15To18ValidationErrorText = SelectorEngine.findOne(
			'.lta-text-input--error',
			this.skills15To18ValidationWrapper
		);
		this._skillsAdultsOrSeniorsValidationErrorText = SelectorEngine.findOne(
			'.lta-text-input--error',
			this.skillsAdultsOrSeniorsValidationWrapper
		);

		this._errorContainer = SelectorEngine.findOne('.lta-edit-players-error-container', this._container);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._saveCta = SelectorEngine.findOne('.save-player-cta', this._form);
		this._saveCta.addEventListener('click', (event) => this.submitEnquiry(event));

		this._exitModal = new Modal(SelectorEngine.findOne('#coach-details-players-exit'), {});

		this._cancelCta = SelectorEngine.findOne('.lta-coach-details__edit-players-back', this._container);
		this._cancelCta.addEventListener('click', () => this._exitModal.show());

		const popupCancel = SelectorEngine.findOne('.lta-coach-details__edit-players-continue', this._container);
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-coach-details__edit-players-exit', this._container);
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});

		this.players = SelectorEngine.find('input[type="checkbox"]', this._container);
		for (const checkbox of this.players) {
			EventHandler.on(checkbox, CLICK_EVENT, (event) => {
				this.handleCheckboxClick(event);
			});
			if (
				checkbox.name === 'skills10AndUnder' ||
				checkbox.name === 'skills11To14' ||
				checkbox.name === 'skills15To18' ||
				checkbox.name === 'skillsAdultsOrSeniors'
			) {
				if (checkbox.checked) {
					this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.push(checkbox.value);
					SelectorEngine.findOne(`.${checkbox.id}`, this._container).classList.remove('u-hidden');
				}
			} else {
				if (checkbox.checked) {
					this.payload.updateCoachDetailsRequest.myPlayers[checkbox.id].push(checkbox.value);
				}
			}
		}

		EventHandler.on(window, 'toggleStatus', (event) => {
			this.status = event.detail.status;
		});
	}

	async submitEnquiry(event) {
		event.preventDefault();
		if (this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.length === 0) {
			this._ageGroupValidationErrorText.textContent = 'Please input a valid answer';
			this.playerAgeGroupsValidationWrapper.classList.add('validation-error');
			return;
		} else {
			if (
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.length !== 0 &&
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.includes('10 and under') &&
				this.payload.updateCoachDetailsRequest.myPlayers.skills10AndUnder.length === 0
			) {
				this._skills10AndUnderValidationErrorText.textContent = 'Please input a valid answer';
				this.skills10AndUnderValidationWrapper.classList.add('validation-error');
				return;
			}
			if (
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.length !== 0 &&
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.includes('11 to 14 years old') &&
				this.payload.updateCoachDetailsRequest.myPlayers.skills11To14.length == 0
			) {
				this._skills11To14ValidationErrorText.textContent = 'Please input a valid answer';
				this.skills11To14ValidationWrapper.classList.add('validation-error');
				return;
			}
			if (
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.length !== 0 &&
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.includes('15 to 18 years old') &&
				this.payload.updateCoachDetailsRequest.myPlayers.skills15To18.length === 0
			) {
				this._skills15To18ValidationErrorText.textContent = 'Please input a valid answer';
				this.skills15To18ValidationWrapper.classList.add('validation-error');
				return;
			}
			if (
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.length !== 0 &&
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.includes('Adults/Seniors') &&
				this.payload.updateCoachDetailsRequest.myPlayers.skillsAdultsOrSeniors.length === 0
			) {
				this._skillsAdultsOrSeniorsValidationErrorText.textContent = 'Please input a valid answer';
				this.skillsAdultsOrSeniorsValidationWrapper.classList.add('validation-error');
				return;
			} else {
				startLoadingAnimation(true);
				try {
					const url = `/api/coachdetails/update`;
					const responseData = await Request.post(url, this.payload);

					const { success } = responseData;
					if (success) {
						const redirectUrl = Manipulator.getDataAttribute(this._container, 'redirect-url');
						window.location.href = redirectUrl;
					} else {
						this._errorContainer.classList.remove('u-hidden');
						this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
					}
				} catch {
					this._errorContainer.classList.remove('u-hidden');
					this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
					this._errorContainer.scrollIntoView();
				} finally {
					stopLoadingAnimation();
				}
			}
		}
	}

	handleCheckboxClick(event) {
		let arrayIndex = event.target.id.split("_")[0];
		if (
			event.target.name === 'skills10AndUnder' ||
			event.target.name === 'skills11To14' ||
			event.target.name === 'skills15To18' ||
			event.target.name === 'skillsAdultsOrSeniors'
		) {
			this.openHideSections(event);
			if (event.target.checked) {
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.push(event.target.value);
			} else {
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups =
					this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.filter(
						(value) => value !== event.target.value
					);
				const allItems = SelectorEngine.find(`#${arrayIndex}`, this._container);
				for (const item of allItems) {
					item.checked = false;
				}
				this.payload.updateCoachDetailsRequest.myPlayers[arrayIndex] = [];
			}
		} else {
			
			if (event.target.checked) {
				
				this.payload.updateCoachDetailsRequest.myPlayers[arrayIndex].push(event.target.value);
			} else {
				this.payload.updateCoachDetailsRequest.myPlayers[arrayIndex] =
					this.payload.updateCoachDetailsRequest.myPlayers[arrayIndex].filter(
						(value) => value !== event.target.value
					);
			}
		}

		if (this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.length > 0) {
			this._ageGroupValidationErrorText.textContent = '';
			this.playerAgeGroupsValidationWrapper.classList.remove('validation-error');

			if (
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.includes('10 and under') &&
				this.payload.updateCoachDetailsRequest.myPlayers.skills10AndUnder.length > 0
			) {
				this._skills10AndUnderValidationErrorText.textContent = '';
				this.skills10AndUnderValidationWrapper.classList.remove('validation-error');
			}
			if (
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.includes('11 to 14 years old') &&
				this.payload.updateCoachDetailsRequest.myPlayers.skills11To14.length > 0
			) {
				this._skills11To14ValidationErrorText.textContent = '';
				this.skills11To14ValidationWrapper.classList.remove('validation-error');
			}
			if (
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.includes('15 to 18 years old') &&
				this.payload.updateCoachDetailsRequest.myPlayers.skills15To18.length > 0
			) {
				this._skills15To18ValidationErrorText.textContent = '';
				this.skills15To18ValidationWrapper.classList.remove('validation-error');
			}
			if (
				this.payload.updateCoachDetailsRequest.myPlayers.playerAgeGroups.includes('Adults/Seniors') &&
				this.payload.updateCoachDetailsRequest.myPlayers.skillsAdultsOrSeniors.length > 0
			) {
				this._skillsAdultsOrSeniorsValidationErrorText.textContent = '';
				this.skillsAdultsOrSeniorsValidationWrapper.classList.remove('validation-error');
			}
		}
	}

	openHideSections(event) {
		if (event.target.checked) {
			SelectorEngine.findOne(`.${event.target.id}`).classList.remove('u-hidden');
		} else {
			SelectorEngine.findOne(`.${event.target.id}`).classList.add('u-hidden');
		}
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalEditPlayers = new EditPlayers();

export default globalEditPlayers;
